import React from "react";

import { NavLink } from "react-router-dom";
import { Menu, type MenuProps } from "antd";

import Icon from "@/components/Icon";
import { URLS } from "@/urls";

const MenuItems = (props) => {
  const {
    defaultOpenKeys,
    defaultSelectedKeys,
    selectedKeys,
    onOpenChange,
    optionalMenuProps,
    onMenuItemClick,
    enableSupportSection,
    enableManagedServicesSection,
    enableNetsgMobileSection,
  } = props;

  const items: MenuProps["items"] = [
    {
      key: URLS.customerUI.dashboard.index.buildPath(),
      icon: <Icon icon="faTachometerAlt" />,
      label: (
        <NavLink to={URLS.customerUI.dashboard.index.buildPath()}>
          <span>Dashboard</span>
        </NavLink>
      ),
    },
    {
      key: URLS.customerUI.serviceDelivery.index.buildPath(),
      icon: <Icon icon="faCalendar" />,
      label: (
        <NavLink to={URLS.customerUI.serviceDelivery.index.buildPath()}>
          <span>Service Delivery</span>
        </NavLink>
      ),
    },
    {
      key: URLS.customerUI.services.index.buildPath(),
      icon: <Icon icon="faNetworkWired" />,
      label: (
        <NavLink to={URLS.customerUI.services.index.buildPath()}>
          <span>Services</span>
        </NavLink>
      ),
    },
    ...(enableNetsgMobileSection
      ? [
          {
            key: URLS.customerUI.netsgMobile.key.buildPath(),
            icon: <Icon pro icon={"faMobile"} />,
            label: <span>Mobile</span>,
            children: [
              {
                key: URLS.customerUI.netsgMobile.services.index.buildPath(),
                label: (
                  <NavLink
                    to={URLS.customerUI.netsgMobile.services.index.buildPath()}
                  >
                    Services
                  </NavLink>
                ),
              },
              {
                key: URLS.customerUI.netsgMobile.pools.index.buildPath(),
                label: (
                  <NavLink
                    to={URLS.customerUI.netsgMobile.pools.index.buildPath()}
                  >
                    Data Pools
                  </NavLink>
                ),
              },
            ],
          },
        ]
      : []),
    {
      key: URLS.customerUI.mobileVoice.index.buildPath(),
      icon: <Icon pro icon={"faMobile"} />,
      label: (
        <NavLink to={URLS.customerUI.mobileVoice.index.buildPath()}>
          <span>Mobile (Legacy)</span>
        </NavLink>
      ),
    },
    ...(enableManagedServicesSection
      ? [
          {
            key: URLS.customerUI.managedServices.index.buildPath(),
            icon: <Icon icon="faTasksAlt" pro />,
            label: (
              <NavLink to={URLS.customerUI.managedServices.index.buildPath()}>
                <span>Managed Services</span>
              </NavLink>
            ),
          },
        ]
      : []),
    {
      key: URLS.customerUI.changeManagement.key.buildPath(),
      icon: <Icon icon="faListAlt" />,
      label: <span>Change Management</span>,
      children: [
        {
          key: URLS.customerUI.changeManagement.changes.index.buildPath(),
          label: (
            <NavLink
              to={URLS.customerUI.changeManagement.changes.index.buildPath()}
            >
              <span>
                <Icon icon="faTasks" /> <span>Notifications</span>
              </span>
            </NavLink>
          ),
        },
        {
          key: URLS.customerUI.changeManagement.requests.index.buildPath(),
          label: (
            <NavLink
              to={URLS.customerUI.changeManagement.requests.index.buildPath()}
            >
              <span>
                <Icon icon="faQuestionSquare" pro /> <span>Requests</span>
              </span>
            </NavLink>
          ),
        },
      ],
    },
    ...(enableSupportSection === true || enableSupportSection === undefined
      ? [
          {
            key: URLS.customerUI.support.index.buildPath(),
            icon: <Icon icon="faHandsHelping" />,
            label: (
              <NavLink to={URLS.customerUI.support.index.buildPath()}>
                <span>Support</span>
              </NavLink>
            ),
          },
        ]
      : []),
    {
      key: URLS.customerUI.reports.index.buildPath(),
      icon: <Icon icon="faFileExport" />,
      label: (
        <NavLink to={URLS.customerUI.reports.index.buildPath()}>
          <span>Reports</span>
        </NavLink>
      ),
    },
    {
      key: URLS.customerUI.monitoring.key.buildPath(),
      icon: <Icon icon="faShieldAlt" />,
      label: <span>Monitoring</span>,
      children: [
        {
          key: URLS.customerUI.monitoring.myNetwork.index.buildPath(),
          label: (
            <NavLink
              to={URLS.customerUI.monitoring.myNetwork.index.buildPath()}
            >
              <span>
                <Icon icon="faChartNetwork" pro /> <span>My Network</span>
              </span>
            </NavLink>
          ),
        },
      ],
    },
  ];

  return (
    <Menu
      mode="inline"
      theme="light"
      defaultOpenKeys={defaultOpenKeys}
      defaultSelectedKeys={defaultSelectedKeys}
      selectedKeys={selectedKeys}
      onOpenChange={onOpenChange}
      onClick={onMenuItemClick}
      style={{ height: "100%", borderRight: 0 }}
      items={items}
      {...optionalMenuProps}
    />
  );
};

export default MenuItems;
